<template>
  <div class="sn-f-b-s report">
    <sn-navigator id="BGCX"  :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s report-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', initial) }]"></sn-breadcrumb>
      <div class="sn-f-b-e sn-title operate">
        <div class="sn-f-s-c">
          <div class="sn-f-c-c sn-pointer title-caption" v-for="item in tabArray" :key="item.itemCode"
          :class="{'interaction': item.itemCode === selectedTab}" @click="changeTab(item.itemCode);">
            {{ item.itemName }}
          </div>
        </div>
      </div>
      <div class="sn-f-1 sn-f-s-1 report-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ reportType === '1' ? '就诊人' : '住院人' }}：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到{{ reportType === '1' ? '就诊人' : '住院人' }}，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <template v-else-if="patientArray.length === 0">
              <div v-if="reportType === '1'" @click="navigateUrl('addition-patient');">
                暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
              <div v-else @click="navigateUrl(isOpenSingleCard ? 'addition-patient' : '/patient/out/homepage');">
                暂无住院人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>

          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : ['就诊卡', '住院号'][reportType -1]}}：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>

          <div class="sn-f-s-c region" v-if="reportType === '2' && hosId === Constants.HOSPITAL_ID_LCRM">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>住院记录：</div>
            </div>
            <el-select :value="historyObj.feeId" @change="funChangeHistory">
              <el-option v-for="(obj, index) in historyList" :label="`${obj.deptName}${obj.feeType === '未超过' ? '' : '-(超出查询期限，请到住院处人工窗口)'}`" :value="obj.feeId" :key="index" :disabled="obj.feeType !== '未超过'"></el-option>
            </el-select>
          </div>

          <!-- 时间筛选按钮 -->
          <template v-if="showChooseDate">
            <div class="sn-f-s-c region">
              <div class="sn-f-s-c patient-title">
                <div class="required">*</div>
                <div>日期范围：</div>
              </div>
              <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="sn-f-s-c region">-</div>
            <div class="sn-f-s-c region">
              <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </template>

          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(handleReport)">
          <div class="sn-table">
            <!-- 核酸报告 -->
            <table v-if="['3'].includes(selectedTab)">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>身份证号</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <!-- 核酸报告查询结果是否显示项目和单号 -->
                  <template  v-if="$sn.getConfig('isNucleicAcidReportQueryProjectSingleNumber')">
                    <th>项目名称</th>
                    <th>检验单号</th>
                  </template>
                  <!-- 核酸报告查询结果是否显示检验结果和报告时间 -->
                  <template v-else-if="$sn.getConfig('isNucleicAcidReportQueryResultTime')">
                    <th>检测结果</th>
                    <th>报告时间</th>
                  </template>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="report.reqNo" v-for="(report, index) in handleReport">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{$sn.encrypted.idCardSerial(selectedPatient.patientIdCardNo)}}</td>
                  <td>{{selectedPatient.phoneEncrypt}}</td>
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <!-- 核酸报告查询结果是否显示项目和单号 -->
                  <template  v-if="$sn.getConfig('isNucleicAcidReportQueryProjectSingleNumber')">
                    <td class="alone-width">{{report.itemName}}</td>
                    <td>{{report.itemReqNo}}</td>
                  </template>
                  <!-- 核酸报告查询结果是否显示检验结果和报告时间 -->
                  <template v-else-if="$sn.getConfig('isNucleicAcidReportQueryResultTime')">
                    <td class="alone-width">{{report.reportAnswer}}</td>
                    <td>{{report.reportDate}}</td>
                  </template>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/report/detail', report, {type: reportType});">查看详情</td>
                </tr>
              </tbody>
            </table>
            <!-- 内镜报告(胃镜报告) 其他报告(超声报告) -->
            <table v-else-if="['5', '20'].includes(selectedTab)">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>身份证号</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <th>项目名称</th>
                  <th>检验单号</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="report.reqNo" v-for="(report, index) in handleReport">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{$sn.encrypted.idCardSerial(selectedPatient.patientIdCardNo)}}</td>
                  <td>{{selectedPatient.phoneEncrypt}}</td>
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <td class="alone-width">{{report.itemName}}</td>
                  <td>{{report.itemReqNo}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/report/detail', report, {type: reportType});">查看详情</td>
                </tr>
              </tbody>
            </table>
            <!-- 全部报告 检查报告 检验报告 病理报告 -->
            <table v-else>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>身份证号</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <th>类别</th>
                  <th>报告名称</th>
                  <th>检查时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="report.reqNo" v-for="(report, index) in handleReport">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{$sn.encrypted.idCardSerial(selectedPatient.patientIdCardNo)}}</td>
                  <td>{{selectedPatient.phoneEncrypt}}</td>
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <td>{{report.category}}</td>
                  <td class="alone-width">{{report.itemClass}}</td>
                  <td>{{report.checkTime}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/report/detail', report, {type: reportType});">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <div class="sn-f-c-c prompt-message" v-if="reportType === '1' && ['0', '1', '2'].includes(selectedTab)">列表仅显示两个月内报告记录、更多报告请按时间筛选查询</div>
        </template>
        <!-- 核酸报告温馨提示 -->
        <div class="prompt-message" v-if="['3'].includes(selectedTab)">{{$sn.getConfig('nucleicAcidReportQueryReminder')}}</div>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(reportInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" :type="isOpenSingleCard ? '1' : reportType" @sendBack="sendBackBindCard"></bind-card>
    </div>

    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import * as Constants from '@/common/utils/constants';
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';
import * as ServiceConfig from '@/common/utils/service-config';

export default {
  mixins: [PatientShareMixin],

  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },

  data() {
    return {
      Constants: Constants,
      hosId: self.$sn.utils.getHospitalId(), // 医院ID
      historyObj: {}, // 住院记录-选中的住院记录
      historyList: [], // 住院记录
      patientArray: [], // 就诊人列表
      selectedPatient: {}, // 当前就诊人
      outCardSerial: '', // 就诊卡号
      outCardSerialFormat: '', // 就诊卡号格式化
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('outRechargeRecordRange')[0], self.$sn.getConfig('outRechargeRecordRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      reportInfo: [], // 报告列表
      allReportInfo: [], // 报告列表
      pageCount: 1, // 当前页码
      isResult: true, // 是否查询到结果
      totalCost: 0, // 总费用
      exhibitionCreatePatient: false, // 是否显示创建就诊人
      exhibitionBindCard: false, // 是否显示绑定就诊卡
      tabArray: [], // 页签列表
      reportType: '1', // 1:门诊 2:住院
      selectedTab: '',
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard'),
      tipsObj: {} // 温馨提示
    };
  },

  computed: {
    // 处理报告信息
    handleReport() {
      let handle = [];
      if (this.reportInfo.length > 0) handle = this.$sn.format.group(this.reportInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },

    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZBG, this.perpetual.FUNCTION_ID_ZYBG][this.reportType - 1];
    },

    // 是否显示时间筛选按钮
    showChooseDate() {
      let bool = true;
      if (this.reportType === '1') {
        // 山大齐鲁医院 核酸报告
        if (this.hosId === Constants.HOSPITAL_ID_SDQL && this.selectedTab === '3') {
          bool = false;
        }
      }
      else if (this.reportType === '2') {
        // 山大齐鲁医院 核酸报告
        if (this.hosId === Constants.HOSPITAL_ID_SDQL && this.selectedTab === '3') {
          bool = false;
        }
        // 聊城人民医院 住院报告
        else if (this.hosId === Constants.HOSPITAL_ID_LCRM) {
          bool = false;
        }
      }
      return bool;
    }
  },

  watch: {
    // 切换就诊人
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.reportInfo = [];
      this.allReportInfo = [];
      this.pageCount = 1;
      if (patient.patientId) {
        let type = this.reportType;
        // 山大齐鲁医院 住院病理报告 直接走就诊人信息
        if (this.hosId === Constants.HOSPITAL_ID_SDQL) {
          type = '1';
        }
        const handle = await Tools.handlePatientInfo(patient, type);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        if (this.outCardSerial) {
          // 门诊
          if (this.reportType === '1') {
            this.searchBtn();
          }
          // 住院
          else {
            if (this.hosId === Constants.HOSPITAL_ID_LCRM) {
              // 获取住院记录
              this.funGetHistoryList();
            }
            else {
              this.searchBtn();
            }
          }
        }
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    },

    // 切换页签
    selectedTab(v) {
      // 温馨提示
      // 内镜报告(胃镜报告)
      if (v === '5' && this.$sn.validate.empty(this.tipsObj[v])) {
        this.tipsObj[v] = true;
        this.$sn.assembly.modal({
          caption: Messages.SEARCH048,
          captionConfirm: '确认',
          isCancel: false
        });
      }
      // 病理报告
      if (v === '4' && this.$sn.validate.empty(this.tipsObj[v])) {
        this.tipsObj[v] = true;
        let caption = Messages.SEARCH049;
        if (this.reportType === '2') {
          caption = Messages.SEARCH050;
        }
        this.$sn.assembly.modal({
          caption: caption,
          captionConfirm: '已了解',
          isCancel: false
        });
      }
    },

    $route(val, old) {
      this.$route.query.type = this.$route.query.type || '1';
      if ((old.path === '/query/report' && val.path !== '/query/report/detail') || (old.path === '/query/report/detail' && val.path !== '/query/report')) {
        this.funLoad();
      }
      else if (old.path === '/query/report/detail' && val.path === '/query/report') {
        if (this.reportType !== this.$route.query.type) {
          this.funLoad();
        }
      }
    },

    // 切换页码
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.reportInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.selectedTab === '0' ? this.paginateResult() : this.searchBtn();
        }
      },
      immediate: true
    }
  },

  created() {
    // 初始化
    this.funLoad();
  },

  methods: {
    /**
     * 2025-04-10 11:25:20 Ywr
     * 初始化加载
    */
    funLoad() {
      this.reportType = this.$route.query.type || '1';
      this.selectedTab = '';
      this.tipsObj = {};
      document.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.handlePatientInfo();
      this.initialReportTopLabel();
    },

    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);

      await Tools.getHospitalConfigInformation([
        this.perpetual.CONFIG_TYPE_NUCLEIC_ACID // 搜索模块
      ]);

      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList') || [];
      if (this.reportType === '2' && this.hosId !== this.perpetual.HOSPITAL_ID_SDQL) {
        // 住院人 - 含有住院号
        if (!this.isOpenSingleCard) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      if (this.patientArray && this.patientArray.length > 0) {
        if (this.reportType === '1') {
          this.selectedPatient = this.$sn.utils.getCurrentPatient();
        }
        else {
          if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
          else this.selectedPatient = this.patientArray.find(item => item.inCardNo) || this.patientArray[0];
        }
      }
    },

    // 初始化报告标签栏
    async initialReportTopLabel() {
      this.tabArray = [];
      let dictList = []; // 字典
      let arr = []; // 前端配置
      if (this.reportType === '1') {
        dictList = await Tools.dict([
          this.perpetual.DICTIONARY_CODE_OUT_REPORT_TYPE
        ]);
        arr = this.$sn.getConfig('outReportType'); // 门诊报告类型
      }
      else {
        dictList = await Tools.dict([
          this.perpetual.DICTIONARY_CODE_IN_REPORT_TYPE
        ]);
        arr = this.$sn.getConfig('inReportType'); // 住院报告类型
      }

      if (arr && arr.length) arr = arr.split(',');
      if (Array.isArray(arr)) {
        dictList = dictList.filter(item => {
          return arr.includes(item.itemCode);
        });
      }
      else dictList = [];
      this.selectedTab = dictList[0]?.itemCode;
      this.tabArray = dictList;
    },

    // 切换页签
    changeTab(code) {
      this.selectedTab = code;
      this.isResult = true;
      this.reportInfo = [];
      this.allReportInfo = [];
      this.pageCount = 1;
      this.searchBtn();
    },

    // 切换就诊人
    changePatient(id) {
      if (this.reportType === '1') {
        if (id) {
          this.selectedPatient = this.patientArray.find(item => item.patientId === id);
          this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
        }
      }
      else {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
      }
    },

    /**
     * 2025-04-08 17:13:52 Ywr
     * 获取住院记录
    */
    funGetHistoryList() {
      const params = {
        url: Swagger.getPaymentInTable,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          cardNo: this.selectedPatient.inCardNo,
          hosId: this.$sn.utils.getHospitalId(),
          idCardNo: this.selectedPatient.patientIdCardNo,
          patId: this.selectedPatient.patientId,
          patName: this.selectedPatient.patientName,
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          projectType: this.$sn.utils.getProjectType(),
          startDate: this.startDate,
          endDate: this.endDate,
          page: this.pageCount,
          size: this.perpetual.PAGINATION_SIZE
        })
      };
      this.historyList = [];
      this.historyObj = {};
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data && result.data.length > 0) {
              this.historyList = result.data.sort((a, b) => b.feeType.length - a.feeType.length);
            }
          }
          else {
            this.$sn.assembly.toast({
              caption: result.msg
            });
          }
        }
        else {
          this.$sn.assembly.toast({
            caption: Messages.C001
          });
        }
      });
    },

    /**
     * 2025-04-08 17:26:41 Ywr
     * 切换住院记录
     * @return {void}
     * @param feeId
     */
    funChangeHistory(feeId) {
      this.historyObj = this.historyList.find(item => item.feeId === feeId);
    },

    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询门诊费用
    async searchBtn() {
      this.isResult = true;
      if (!this.outCardSerial) {
        if (this.reportType === '1') {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) this.navigateUrl('addition-card');
            }
          });
        }
        else {
          this.getShowToast('请先添加住院人');
        }
      }
      else {
        if (this.$sn.validate.empty(this.startDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
          return false;
        }
        if (this.$sn.validate.empty(this.endDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
          return false;
        }
        const start = new Date(this.startDate).getTime();
        const end = new Date(this.endDate).getTime();
        if (end < start) {
          this.getShowToast('结束日期不能早于开始日期');
          return false;
        }
        if (this.selectedTab === '0') {
          this.$sn.assembly.loading(true);
          await Promise.all([this.getCheckList(), this.getExamineList()]);
          this.$sn.assembly.loading(false);
          if (this.allReportInfo.length > 0) {
            this.paginateResult();
          }
        }
        else {
          if (this.selectedTab === '1') {
            this.getCheckList();
          }
          else if (this.selectedTab === '2') {
            this.getExamineList();
          }
          // 其他报告(超声报告)
          else if (this.selectedTab === '20') {
            this.getOtherList();
          }
          // 内镜报告(胃镜报告)
          else if (this.selectedTab === '5') {
            this.getOtherList();
          }
          // 核酸报告
          else if (this.selectedTab === '3') {
            this.getOtherList();
          }
          // 病理报告
          else if (this.selectedTab === '4') {
            this.getCheckList();
          }
        }
      }
    },
    // 检查报告列表
    getCheckList() {
      const sheetType = {
        '1': '0',
        '2': '1'
      };
      let obj = {
        cardNo: this.outCardSerial,
        endDate: this.endDate,
        startDate: this.startDate
      };
      if (this.reportType === '2' && this.hosId === Constants.HOSPITAL_ID_LCRM) {
        if (!this.historyObj.cardNo) {
          this.getShowToast('请先选择住院记录');
          return false;
        }
        obj = {
          cardNo: this.historyObj.cardNo,
          startDate: this.historyObj.inDate,
          endDate: this.historyObj.outDate
        };
      }
      // 病理报告
      if (this.selectedTab === '4') {
        obj = {
          ...obj,
          type: 'BLBG'
        };
      }
      const params = {
        url: Swagger.getCheckTable,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          hosId: this.$sn.utils.getHospitalId(),
          page: this.pageCount,
          patId: this.selectedPatient.patientId,
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          projectType: this.$sn.utils.getProjectType(),
          sheetType: sheetType[this.reportType], // 0:门诊 1:住院
          size: this.selectedTab === '0' ? 100000 : this.perpetual.PAGINATION_SIZE,
          ...obj
        })
      };
      this.$sn.assembly.loading(true);
      return this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          result.data.map(item => {
            this.$set(item, 'category', '检查报告');
            this.$set(item, 'reportType', 'check');
          });
          if (this.selectedTab === '0') this.allReportInfo = this.allReportInfo.concat(result.data);
          else {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.reportInfo = result.data;
              this.totalCost = result.totalFee || 0;
            }
            else this.reportInfo = this.reportInfo.concat(result.data);
          }
        }
        else {
          if (this.selectedTab !== '0') this.isResult = false;
        }
      });
    },
    // 检验报告列表
    getExamineList() {
      const sheetType = {
        '1': '0',
        '2': '1'
      };
      let obj = {
        cardNo: this.outCardSerial,
        endDate: this.endDate,
        startDate: this.startDate
      };
      if (this.reportType === '2' && this.hosId === Constants.HOSPITAL_ID_LCRM) {
        if (!this.historyObj.cardNo) {
          this.getShowToast('请先选择住院记录');
          return false;
        }
        obj = {
          cardNo: this.historyObj.cardNo,
          endDate: this.historyObj.outDate,
          startDate: this.historyObj.inDate
        };
      }
      const params = {
        url: Swagger.getExamineTable,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          hosId: this.$sn.utils.getHospitalId(),
          page: this.pageCount,
          patId: this.selectedPatient.patientId,
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          projectType: this.$sn.utils.getProjectType(),
          sheetType: sheetType[this.reportType], // 0:门诊 1:住院
          size: this.selectedTab === '0' ? 100000 : this.perpetual.PAGINATION_SIZE,
          ...obj
        })
      };
      this.$sn.assembly.loading(true);
      return this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          result.data.map(item => {
            this.$set(item, 'category', '检验报告');
            this.$set(item, 'reportType', 'examine');
          });
          if (this.selectedTab === '0') this.allReportInfo = this.allReportInfo.concat(result.data);
          else {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.reportInfo = result.data;
              this.totalCost = result.totalFee || 0;
            }
            else this.reportInfo = this.reportInfo.concat(result.data);
          }
        }
        else {
          if (this.selectedTab !== '0') this.isResult = false;
        }
      });
    },

    /**
     * 2025-12-15 13:52:02 Ywr
     * 山大齐鲁 其他报告列表
    */
    getOtherList() {
      // 清空数据
      this.reportInfo = [];
      this.isLoading = true;
      let path = '';
      let params = this.$sn.format.xml({
      }, true);
      if (this.hosId === Constants.HOSPITAL_ID_SDQL) {
        // 内镜报告(胃镜报告) 其他报告(超声报告)
        if (['5', '20'].includes(this.selectedTab)) {
          path = 'b3eb74dc-5a4c-410d-8183-b221f8105a75';
          params = `
            <Request>
              <PatientName>${this.selectedPatient.patientName}</PatientName>
              <IdCardNo>${this.selectedPatient.patientIdCardNo}</IdCardNo>
              <StartDate>${this.startDate}</StartDate>
              <EndDate>${this.endDate}</EndDate>
              <Type>${{ '5': '1', '20': '2' }[this.selectedTab]}</Type>
            </Request>`;
        }
        else if (['3'].includes(this.selectedTab)) {
          path = 'eb037407-6c0f-4ee4-9c34-a7c33c18cb3f';
          params = `
            <Request>
              <PatientName>${this.selectedPatient.patientName}</PatientName>
              <IdCardNo>${this.selectedPatient.patientIdCardNo}</IdCardNo>
            </Request>`;
        }
      }
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), path]),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(params)
      }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                if (result.data.Data && result.data.Data.length > 0) {
                  result.data.Data.map(item => {
                    this.$set(item, 'category', this.tabArray.find(el => el.itemCode === this.selectedTab).itemName);
                    this.$set(item, 'reportType', this.selectedTab);
                  });
                  this.reportInfo = result.data.Data;
                  this.totalCost = result.totalFee || 0;
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.data.ResultMsg,
                  isCancel: false
                });
              }
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    // 分页
    paginateResult() {
      this.$sn.assembly.loading(true);
      const start = (this.pageCount - 1) * this.perpetual.PAGINATION_SIZE;
      const end = this.pageCount * this.perpetual.PAGINATION_SIZE;
      this.allReportInfo = this.$sn.format.digitalSort(this.allReportInfo, '2', 'checkTime');
      if (this.isResult) this.reportInfo = this.allReportInfo;
      if (this.allReportInfo.slice(start, end).length < this.perpetual.PAGINATION_SIZE) this.isResult = false;
      if (this.allReportInfo.slice(start, end).length === 0) this.isResult = false;
      this.$sn.assembly.loading(false);
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.reportInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/report/detail' && !this.$sn.validate.empty(item)) {
        item.cardNo = this.outCardSerial;
        this.$sn.utils.setHospitalSessionStorage('report_Info', {
          ...item,
          patient: this.selectedPatient,
          selectedTab: this.selectedTab // 当前报告类型
        });
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.report {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .report-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .sn-table {
        td {
          max-width: 200px;
        }

        .alone-width {
          max-width: 250px;
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
